import { del, get, post } from "aws-amplify/api";
import { API_NAME_VELAVU, normalizePromiseError, operationToJSON } from "../util/amplify-utils";
export default class VelavuAPIDFU {
    //This method returns compatible DFU images for a device
    getDFUImages(deviceID) {
        return normalizePromiseError(operationToJSON(get({
            apiName: API_NAME_VELAVU,
            path: `/dfu/device/${deviceID}/images`,
        })));
    }
    // This method returns all DFU requests.
    // Provide a deviceID to get all DFU requests for only a single device.
    getDFURequests(deviceID) {
        let path;
        if (deviceID === undefined) {
            path = "/dfu";
        }
        else {
            path = `/dfu/device/${deviceID}`;
        }
        return normalizePromiseError(operationToJSON(get({
            apiName: API_NAME_VELAVU,
            path: path,
        })));
    }
    // This method creates a device firmware update request.
    // The device firmware name should match a name returned by the GET dfu/device/.device_id/images request.
    // Invalid firmware names will return a 400 bad request
    createDFURequest(deviceID, imageName) {
        return normalizePromiseError(operationToJSON(post({
            apiName: API_NAME_VELAVU,
            path: `/dfu/device/${deviceID}`,
            options: {
                body: {
                    name: imageName,
                },
            },
        })));
    }
    //This method deletes a DFU request.
    deleteDFURequest(requestID) {
        return normalizePromiseError(del({
            apiName: "Velavu-API",
            path: `/dfu/${requestID}`,
        }).response);
    }
}
//# sourceMappingURL=velavu-api-dfu.js.map